module.exports = __webpack_public_path__ + "img/nay.8f0cc95c.png";